/**
 * Package-snapshot chip (Epic 4 — Story 4.4, AC #3, UX-DR5/S5)
 *
 * Neutraal/informatief label — geen kleur buiten het palet, geen rood (dit
 * is geen foutstatus). Gebruikt op elke plek waar een afgeronde
 * `core_tasks_v2`-beoordeling haar pakket-snapshot toont (detail-weergave +
 * print).
 */

const MONTH_NAMES_NL = [
  'januari', 'februari', 'maart', 'april', 'mei', 'juni',
  'juli', 'augustus', 'september', 'oktober', 'november', 'december',
];

/** "12 maart 2026" uit een ISO-datum(tijd)-string. */
function formatDutchDate(iso: string): string {
  const datePart = iso.slice(0, 10);
  const [year, month, day] = datePart.split('-').map(Number);
  if (!year || !month || !day) return iso;
  return `${day} ${MONTH_NAMES_NL[month - 1] ?? ''} ${year}`;
}

interface PackageSnapshotChipProps {
  finalizedAt: string;
  className?: string;
}

export function PackageSnapshotChip({ finalizedAt, className }: PackageSnapshotChipProps) {
  return (
    <span
      data-testid="package-snapshot-chip"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-[#E2E8F0] text-[#1E293B] ${className ?? ''}`}
    >
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Beoordeeld pakket vastgelegd op {formatDutchDate(finalizedAt)}
    </span>
  );
}
